<template>
    <div class="componente-principal">
        <br/>
        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="Hoje"
            @click.native="mapaproducao('hoje')"/><br/>

        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="Últimos 7 dias"
            @click.native="mapaproducao('7dias')"/><br/>

        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="Este mês"
            @click.native="mapaproducao('estemes')"/><br/>

        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="Mês anterior"
            @click.native="mapaproducao('mesanterior')"/><br/>

        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="Últimos 30 dias"
            @click.native="mapaproducao('30dias')"/><br/>

        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="Selecionar Período"
            @click.native="mapaproducao('periodo')"/><br/>

        
    </div>
</template>

<script>

import moment from 'moment';

import Botao from '@/components/shared/Botao.vue';

    
export default {
    name: 'MenuMapaProducao',
    components: {
        Botao
    },



    methods:{

        mapaproducao(periodo){

            var data1 = new Date();
            var data2 = new Date();

            if (periodo=='periodo'){
                this.$router.push(`/mapaproducao/selecionarperiodo`);
            } else {

                if (periodo=='7dias'){
                    data1.setDate(data1.getDate()-7);
                } else if (periodo=='estemes'){
                    data1.setDate(1);
                    data2 = new Date(data1.getFullYear(), data1.getMonth() + 1, 0);
                } else if (periodo=='mesanterior'){
                    data1 = new Date(data1.getFullYear(), data1.getMonth()-1, 1);
                    data2 = new Date(data2.getFullYear(), data2.getMonth(), 0);
                } else if (periodo=='30dias'){
                    data1.setDate(data1.getDate()-30);
                }

                

                var strData1 = moment(data1).format('DD/MM/YYYY');
                var strData2 = moment(data2).format('DD/MM/YYYY');

                this.$router.push(`/mapaproducao/${encodeURIComponent(strData1)}/${encodeURIComponent(strData2)}/1`);

            }


        }

    }

}
</script>